<template>
  <v-card>
    <profit-tabs></profit-tabs>
    <v-card-title v-show="false" class="secondary--text">{{title}}</v-card-title>

    <v-card-text>
      <v-row>
        <v-col cols="12" md="2">
          <v-select
              :menu-props="{ bottom: true, offsetY: true }"
              class="rounded-lg"
              :items="wareLevels"
              v-model="filters.level"
              label="سطح خدمت"
              @change="setFilterWithWareLevel"
          />
        </v-col>
        <v-col cols="12" md="2">
          <v-text-field
              class="rounded-lg"
              label="از کد "
              type="number"
              v-model="filters.code__gte"
          />
        </v-col>
        <v-col cols="12" md="2">

          <v-text-field
              class="rounded-lg"
              label="تا کد "
              type="number"
              v-model="filters.code__lte"
          />
        </v-col>
        <v-col cols="12" md="3">
          <ware-select
              :multiple="true"
              :show-info="false"
              label="انتخاب خدمت"
              :clearable="true"
              v-model="filtered_ware"
              type="wares"
              :is-service="true"
              :show-main-unit="false"
              @change="setWareFilter()"
          />
        </v-col>
        <v-col cols="12" md="3">
          <v-select
              :menu-props="{ bottom: true, offsetY: true }"
              class="rounded-lg"
              :items="waresStatuses"
              v-model="filters.status"
              label="وضعیت خدمت"
              @change="setFilterWithWareStatus"
          ></v-select>
        </v-col>


        <v-col cols="12" class="all-wares-inventory">
          <m-datatable :api-url="url" :headers="headers" :filters.sync="filters" ref="datatable" :additional-applied-filters="appliedFilters">
            <template #item.gross_profit_margin_percent="{ item }">
              <span :class="(item.gross_profit_margin_percent >= 0)?'success_important--text':'danger--text'">
                {{item.gross_profit_margin_percent}} %
              </span>
            </template>

          </m-datatable>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import _ from "lodash";
import wareApiMixin from "@/mixin/wareApi";
import MDatatable from "@/components/m-datatable";
import OpenInventoryBtn from "@/components/btns/OpenInventoryBtn";
import SortInventory from "./SortInventory.vue";
import WarehouseSelect from "@/components/selects/WarehouseSelect.vue";
import ProfitTabs from "@/views/panel/inventory/ware/profitTabs";

export default {
  components: {ProfitTabs, MDatatable, OpenInventoryBtn, SortInventory, WarehouseSelect },
  mixins: [wareApiMixin],
  data() {
    return {
      filter_warehouses: [0],
      filtered_ware: null,
      appliedFilters: [],

      url: "reports/serviceProfitRepor",
      headers: [
        {
          text: "کد خدمت",
          value: "code",
          sortable: false,
        },
        {
          text: "نام خدمت",
          value: "name",
          sortable: false,
        },
        {
          text: "فروش ناخالص",
          value: "gross_sale_value",
          type: "numeric",
          sortable: false,
          filterable: false,
        },
        {
          text: "برگشت از فروش",
          value: "back_from_sale_value",
          type: "numeric",
          sortable: false,
          filterable: false,
        },
        {
          text: "تخفیفات خالص ",
          value: "discount",
          type: "numeric",
          sortable: false,
          filterable: false,
        },
        {
          text: "فروش خالص",
          value: "net_sales",
          type: "numeric",
          sortable: false,
          filterable: false,
        },
      ],
      filters: {
        level: 3,
      },
    };
  },
  created() {
  },
  mounted() {
  },

  methods: {
    setFilterWithWareLevel() {
      let filter_set_done = false
      for (let filter of this.appliedFilters) {
        if (filter.text == 'سطح خدمت  ') {
          filter.value = this.wareLevelName(this.filters.level)
          filter_set_done = true
        }
      }
      if (!filter_set_done) {
        this.appliedFilters.push(
            {
              text: 'سطح خدمت  ',
              typeText: null,
              value: this.wareLevelName(this.filters.level)
            }
        )
      }

    },
    setFilterWithWareStatus() {
      let filter_set_done = false
      for (let filter of this.appliedFilters) {
        if (filter.text == 'وضعیت خدمت  ') {
          filter.value = this.wareStatusName(this.filters.status)
          filter_set_done = true
        }
      }
      if (!filter_set_done) {
        this.appliedFilters.push(
            {
              text: 'وضعیت خدمت  ',
              typeText: null,
              value: this.wareStatusName(this.filters.status)
            }
        )
      }

    },
    wareStatusName(value) {
      for (let waresStatus of this.waresStatuses) {
        if (waresStatus.value == value) {
          return waresStatus.text
        }
      }
    },
    wareLevelName(value) {
      for (let wareLevel of this.wareLevels) {
        if (wareLevel.value == value) {
          return wareLevel.text
        }
      }
    },


    setWareFilter() {
      let filter_wares_string = ''
      this.filtered_ware.forEach(function (obj) {
        filter_wares_string += obj.id
        filter_wares_string += ','
      })
      filter_wares_string = filter_wares_string.slice(0, -1)
      this.filters.id__in = filter_wares_string
      this.$refs.datatable.getDataFromApi()
    },
  },
  computed: {
    title() {
      return this.setDocumentTitle('گزارش سود خدمات')
    },
  }
};
</script>

<style lang="scss">
</style>
